<template>
    <div
        v-if="isActive"
        class="relative z-10 px-[20px] lg:px-[40px] py-[12px] text-[16px] leading-5 font-oceanside bg-white border-b border-t border-gray-DFDFDF"
    >
        <div class="flex justify-between">
            <div class="flex flex-wrap items-center">
                <div>
                    <span class="font-semibold">{{ $t('COLOR_PALETTE') }}&nbsp;</span>
                </div>
                <div>
                    <span>{{ usedColorCount }}/{{ swatchSlots.length }} {{ $t('USED') }}</span>
                </div>
                <tooltip-button
                    :tooltip-text="$t('COLOR_PALETTE_TOOLTIP')"
                />
            </div>
            <div class="flex items-center gap-[8px]">
                <modal-button
                    @confirm="handleOriginal"
                    :modal-heading="$t('ORIGINAL_SELECTIONS_HEADING')"
                    :modal-copy="$t('ORIGINAL_SELECTIONS_COPY')"
                >
                    <template #cta>
                        <div class="flex items-center gap-1 whitespace-nowrap">
                            <span>{{ $t('RESET_TO_ORIGINAL') }}</span>
                        </div>
                    </template>
                </modal-button>
                <span>|</span>
                <modal-button
                    @confirm="handleClear"
                    :modal-heading="$t('CLEAR_ALL_SELECTIONS_HEADING')"
                    :modal-copy="$t('CLEAR_ALL_SELECTIONS_COPY')"
                >
                    <template #cta>
                        <div class="whitespace-nowrap">
                            {{ $t('CLEAR_ALL_LINK_TEXT') }}
                        </div>
                    </template>
                </modal-button>
            </div>
        </div>
        <!-- <div class="flex flex-wrap items-center justify-between gap-3 mb-2">
            <div class="flex justify-between w-full">
                <div class="flex gap-4">
                    <step-options-color-controls-swatches
                        :options="swatchOptions"
                        @updateColorIsActive="handleUpdateColorIsActive"
                    />
                </div>
                <button
                    v-if="isMobile"
                    class="mr-[20px] underline flex items-center"
                    @click="openPaintfillList"
                >
                    <img src="../assets/images/icons/list.svg" class="w-4 h-4 mr-1" />
                    {{ $t('PAINTFILL_LIST') }}
                </button>
                <button
                    type="button"
                    class="flex items-center focus:outline-none focus:ring-1 focus:ring-black ring-offset-4
                    mr-[20px] lg:mr-[40px] mt-[12px]"
                    :aria-expanded="isAnyColorActive"
                    @click="handleToggleColorPalette($event)"
                >
                    <img
                        src="../assets/images/icons/arrow.svg"
                        class="w-4 h-4 transition-transform duration-300 ease-in-out"
                        :class="isAnyColorActive ? '-rotate-90' : 'rotate-90'"
                        alt="Color palette caret"
                    />
                </button>
            </div>
        </div> -->
        <transition name="cz3__palette-drop">
            <div
                v-if="isAnyColorActive"
                v-click-outside="clickOutsideConfig"
                :class="[
                    'absolute left-[20px] right-[20px] lg:left-[0px] lg:right-[0] top-full z-20 border-b border-gray-DFDFDF bg-white',
                    'px-[20px] lg:px-[40px] shadow-lg mb-4',
                ]"
            >
                <master-palette
                    class="h-[200px] max-h-[20vh] overflow-y-auto -mx-[4px] overflow-x-hidden"
                    @updateColorIsSelected="handleUpdateColorIsSelected($event)"
                />
            </div>
        </transition>
    </div>
</template>

<script>
    // import StepOptionsColorControlsSwatches from './StepOptionsColorControlsSwatches.vue';
    import MasterPalette from './MasterPalette.vue';
    import ModalButton from './buttons/ModalButton.vue';
    import allStores from '../stores/all';
    import TooltipButton from './buttons/TooltipButton.vue';

    import { PREVIEW_IMAGE_PAINTFILL_COLOR_PLACEMENTS } from '../constants';

    const clickOutsideHandlerKey = Symbol('clickOutsideHandler');

    const clickOutsideDirective = {
        beforeMount(el, binding) {
            el[clickOutsideHandlerKey] = (event) => {
                const config = binding.value;
                const handler = typeof config === 'function' ? config : config?.handler;
                const isActive = typeof config === 'function' ? true : config?.isActive !== false;

                if (!isActive || typeof handler !== 'function') {
                    return;
                }

                const path = event.composedPath?.() || [];
                const isInside = path.length ? path.includes(el) : el.contains(event.target);

                if (!isInside) {
                    handler(event);
                }
            };

            document.addEventListener('click', el[clickOutsideHandlerKey], true);
        },

        unmounted(el) {
            document.removeEventListener('click', el[clickOutsideHandlerKey], true);
            delete el[clickOutsideHandlerKey];
        },
    };

    export default {
        mixins: [allStores],
        components: {
            // StepOptionsColorControlsSwatches,
            MasterPalette,
            ModalButton,
            TooltipButton,
        },
        directives: {
            clickOutside: clickOutsideDirective,
        },
        props: {
            isActive: {
                type: Boolean,
                required: true,
            },
        },
        data() {
            return {
                activeColorValue: null,
                lastEditedColorValue: null,
                ignoredColorActiveEvent: null,
            };
        },
        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },

            isMobile() {
                return this.appStore?.isMobile;
            },

            masterPalette() {
                return this.customizerStore?.masterPalette || [];
            },

            swatchSlots: {
                get() {
                    return this.customizerStore?.paletteSwatchSlots
                        || ['__empty__-0', '__empty__-1', '__empty__-2', '__empty__-3'];
                },
                set(nextSlots) {
                    this.customizerStore?.setPaletteSwatchSlots(nextSlots);
                },
            },

            selectedPaletteValues() {
                return this.masterPalette
                    .filter((option) => option.selected)
                    .map((option) => option.value);
            },

            swatchOptions() {
                return this.swatchSlots.map((slotValue, index) => {
                    if (this.isEmptySlotValue(slotValue)) {
                        const emptyValue = this.emptySlotValue(index);

                        return {
                            value: emptyValue,
                            label: '',
                            color: 'NONE',
                            selected: false,
                            placeholder: false,
                            active: emptyValue === this.activeColorValue,
                        };
                    }

                    const option = this.masterPalette.find((paletteOption) => paletteOption.value === slotValue);

                    if (!option) {
                        const emptyValue = this.emptySlotValue(index);

                        return {
                            value: emptyValue,
                            label: '',
                            color: 'NONE',
                            selected: false,
                            placeholder: false,
                            active: emptyValue === this.activeColorValue,
                        };
                    }

                    return {
                        ...option,
                        active: slotValue === this.activeColorValue,
                    };
                });
            },

            isAnyColorActive() {
                return this.swatchOptions.some((option) => option.active);
            },

            usedColorCount() {
                return this.swatchSlots.filter((slotValue) => !this.isEmptySlotValue(slotValue)).length;
            },

            clickOutsideConfig() {
                return {
                    handler: this.handleClickOutside,
                    isActive: this.isAnyColorActive,
                };
            },
        },
        watch: {
            selectedPaletteValues: {
                immediate: true,
                handler(newValues) {
                    const normalizedValues = Array.isArray(newValues) ? newValues : [];

                    const nextSlots = this.swatchSlots.map((slotValue, index) => {
                        if (this.isEmptySlotValue(slotValue)) {
                            return this.emptySlotValue(index);
                        }

                        if (normalizedValues.includes(slotValue)) {
                            return slotValue;
                        }

                        return this.emptySlotValue(index);
                    });

                    normalizedValues.forEach((selectedValue) => {
                        if (nextSlots.includes(selectedValue)) {
                            return;
                        }

                        const firstEmptyIndex = nextSlots.findIndex((slotValue) => this.isEmptySlotValue(slotValue));

                        if (firstEmptyIndex !== -1) {
                            nextSlots[firstEmptyIndex] = selectedValue;
                        }
                    });

                    this.swatchSlots = nextSlots;

                    if (this.activeColorValue && !this.swatchSlots.includes(this.activeColorValue)) {
                        this.activeColorValue = null;
                    }
                },
            },
        },
        methods: {
            handleClickOutside(event) {
                this.ignoredColorActiveEvent = event;
                this.activeColorValue = null;

                setTimeout(() => {
                    if (this.ignoredColorActiveEvent === event) {
                        this.ignoredColorActiveEvent = null;
                    }
                }, 0);
            },

            openPaintfillList() {
                this.appStore.openNestedPanel('allColorLocations');
            },

            async handleOriginal() {
                this.handleClear({ showRawPaintfillPreview: false });
                await this.$nextTick();
                const colors = this.customizerStore.defaultColors;

                const style = this.viewController.selectedAtPlacement('PutterParent');

                const styleColors = colors.find((x) => x.SKU?.trim() === style.custom['v-id']);

                if (styleColors) {
                    const masterPalette = this.customizerStore.masterPalette;
                    const placements = Object.values(PREVIEW_IMAGE_PAINTFILL_COLOR_PLACEMENTS).flat();

                    const newPalette = [];

                    // Collect master palette.
                    // eslint-disable-next-line no-restricted-syntax
                    for (const key of Object.keys(styleColors)) {
                        if (!placements.includes(key)) {
                            // eslint-disable-next-line no-continue
                            continue;
                        }

                        const value = styleColors[key]?.trim();
                        if (value && value !== 'Raw' && value !== 'N/A') {
                            const color = masterPalette.find((x) => x.id === value);
                            if (color) {
                                const selected = newPalette.find((x) => x.id === color.id);
                                if (!selected) {
                                    newPalette.push(color);
                                }
                            }
                        }
                    }

                    // Clear selections.
                    this.masterPalette.forEach((paletteOption) => {
                        this.customizerStore.setColorSelected(paletteOption.value, false);
                    });

                    // Select back if selected.
                    this.masterPalette.forEach((paletteOption) => {
                        const selected = newPalette.find((x) => paletteOption.id === x.id);
                        if (selected) {
                            this.customizerStore.setColorSelected(paletteOption.value, true);
                        }
                    });

                    // Now make palette selections.
                    // eslint-disable-next-line no-restricted-syntax
                    for (const key of Object.keys(styleColors)) {
                        if (!placements.includes(key)) {
                            // eslint-disable-next-line no-continue
                            continue;
                        }

                        // First set selection back to placeholder.
                        const placement = this.viewController.findPlacement(key);
                        if (placement) {
                            const placeholder = placement.components.find((x) => x.placeholder);
                            if (placeholder) {
                                this.viewController.updateComponent(key, placement.code);
                            }
                        }

                        const value = styleColors[key]?.trim();

                        let palette = newPalette.find((x) => x.id === value);

                        if (value === 'Raw') {
                            palette = masterPalette.find((x) => x.raw);
                        }

                        // Select from palette.
                        if (palette) {
                            this.customizerStore?.requestStepSubOptionColorChange(key, palette);
                        }
                    }
                } else {
                    this.handleClear();
                }
            },

            handleClear({ showRawPaintfillPreview = true } = {}) {
                const stepSubOptionPlacementCodes = Object.values(this.customizerStore.uiStepSubOptions || {})
                    .filter(Array.isArray)
                    .flat()
                    .map((option) => option.name);

                this.masterPalette.forEach((paletteOption) => {
                    this.customizerStore.setColorSelected(paletteOption.value, false);
                });

                this.swatchSlots = this.swatchSlots.map((_, index) => this.emptySlotValue(index));
                this.customizerStore.clearStepSubOptionColorSelections();

                stepSubOptionPlacementCodes.forEach((placementCode) => {
                    const placement = this.viewController.findPlacement(placementCode);
                    const placeholder = placement?.components?.find((component) => component.placeholder);

                    if (placement && placeholder) {
                        this.viewController.updateComponent(placement.code, placeholder.code);
                    }
                });

                this.customizerStore.setPaintfillRawPreviewActive(showRawPaintfillPreview);
                this.customizerStore.stateChanged(false);

                this.activeColorValue = null;
            },

            emptySlotValue(index) {
                return `__empty__-${index}`;
            },

            isEmptySlotValue(value) {
                return typeof value === 'string' && value.startsWith('__empty__-');
            },

            handleUpdateColorIsSelected(selection) {
                const nextValue = this.customizerStore
                    .requestPaletteSlotColorChange(this.activeColorValue, selection, {
                        source: 'stepOptionsColorControls',
                    });

                if (!nextValue) {
                    return;
                }

                this.activeColorValue = nextValue;
                this.lastEditedColorValue = nextValue;
            },

            handleUpdateColorIsActive(value, event) {
                if (event && event === this.ignoredColorActiveEvent) {
                    this.ignoredColorActiveEvent = null;
                    return;
                }

                if (!this.swatchSlots.includes(value)) {
                    return;
                }

                const nextValue = this.activeColorValue === value ? null : value;

                this.activeColorValue = nextValue;

                if (nextValue) {
                    this.lastEditedColorValue = nextValue;
                }
            },

            nextActiveColorValue() {
                const firstOpenSlot = this.swatchSlots.find((slotValue) => this.isEmptySlotValue(slotValue));

                if (firstOpenSlot) {
                    return firstOpenSlot;
                }

                if (this.lastEditedColorValue && this.swatchSlots.includes(this.lastEditedColorValue)) {
                    return this.lastEditedColorValue;
                }

                return this.swatchSlots[this.swatchSlots.length - 1] || null;
            },

            handleToggleColorPalette(event) {
                if (event && event === this.ignoredColorActiveEvent) {
                    this.ignoredColorActiveEvent = null;
                    return;
                }

                if (this.isAnyColorActive) {
                    this.activeColorValue = null;
                } else {
                    this.activeColorValue = this.nextActiveColorValue();
                }
            },
        },
    };
</script>

<style>
    .cz3__palette-drop-enter-active,
    .cz3__palette-drop-leave-active {
        transform-origin: top;
        transition:
            opacity 220ms ease,
            transform 220ms ease;
    }

    .cz3__palette-drop-enter-from,
    .cz3__palette-drop-leave-to {
        opacity: 0;
        transform: translateY(-12px) scaleY(0.98);
    }

    .cz3__palette-drop-enter-to,
    .cz3__palette-drop-leave-from {
        opacity: 1;
        transform: translateY(0) scaleY(1);
    }
</style>
